import PropTypes from 'prop-types';

const ConnectionErrorIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.4963855,8 C29.3783133,8 35.1036145,13.0127505 36.3180723,19.5992714 C36.8385542,19.5409836 37.3012048,19.4826958 37.8216867,19.4826958 C43.4313253,19.4826958 48,24.0874317 48,29.7413479 C48,35.3952641 43.4313253,40 37.8216867,40 L37.8216867,40 L7.51807229,40 C3.35421687,40 0,36.6193078 0,32.4225865 C0,28.2258652 3.35421687,24.845173 7.51807229,24.845173 C7.92289157,24.845173 8.26987952,24.9034608 8.6746988,24.9617486 C8.50120482,24.0874317 8.38554217,23.154827 8.38554217,22.1639344 C8.38554217,14.3533698 14.6891566,8 22.4963855,8 Z M31.3946159,21.3583443 C33.2370777,19.515123 30.4547017,16.7804842 28.6381092,18.5978256 L28.6381092,18.5978256 L23.993151,23.2446987 L19.3510671,18.5978256 C17.5373489,16.7833597 14.7808421,19.5438784 16.591686,21.3583443 L16.591686,21.3583443 L21.2366442,26.0023418 L16.591686,30.6492149 C14.7808421,32.4608053 17.5373489,35.2213239 19.3510671,33.406858 L19.3510671,33.406858 L23.993151,28.7628605 L28.6381092,33.406858 C30.448953,35.2213239 33.2083341,32.4608053 31.3946159,30.6492149 L31.3946159,30.6492149 L26.7525321,26.0023418 Z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  </div>
);

ConnectionErrorIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

ConnectionErrorIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default ConnectionErrorIcon;
